import Vue from 'vue'
import VeeValidate from 'vee-validate'

//@ts-ignore
Vue.use(VeeValidate, {
    // Only validates when a user has left the field and the value changes
    events: 'change'
})
